import api from './api';

const dashboardService = {
  async getStats() {
    return api.get('/dashboard/stats');
  },

  async getAtRisk() {
    return api.get('/dashboard/at-risk');
  },

  async getDivisionStats() {
    return api.get('/dashboard/division-stats');
  },
  
   // ── Compliance records (dumped daily from external server) ───
  // GET /compliance  →  returns all rows from the compliance table
  getCompliance: () =>
    api.get('/compliance'),
 
  // ── Compliance summary KPIs only (lighter call) ─────────────
  getComplianceSummary: () =>
    api.get('/compliance/summary'),
};

export default dashboardService;